import { Directive, inject, output, input } from '@angular/core';
import { SnackbarService } from '@dss-libs/shared/utility/common-services';
import { EventTypeEnum } from '@dss-libs/shared/type/common-types';
import { TranslocoService } from '@jsverse/transloco';

@Directive({
  selector: '[dssLibsUiDragAndDrop]',
  host: {
    '(dragover)': 'onDragOver($event)',
    '(dragleave)': 'onDragLeave($event)',
    '(drop)': 'onDrop($event)',
  },
})
export class DragAndDropDirective {
  readonly fileDropped = output<FileList>();
  readonly allowedFileExtensions = input<string[]>();

  private snackBarService = inject(SnackbarService);
  private transLocoService = inject(TranslocoService);

  onDragOver(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }

  onDragLeave(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      if (this.isFilesExtensionsAllValid(files)) {
        this.fileDropped.emit(files);
      } else {
        this.snackBarService.showToaster(EventTypeEnum.ERROR, 'ERRORS.FILE_NOT_SUPPORTED');
      }
    }
  }

  private isFilesExtensionsAllValid(fileList: FileList): boolean {
    if (!this.allowedFileExtensions()) {
      return true;
    }
    let isValid = true;
    for (const key in fileList) {
      if (isNaN(parseInt(key))) {
        continue;
      }
      const file = fileList[key];
      if (!this.isFileExtensionValid(file)) {
        isValid = false;
        break;
      }
    }
    return isValid;
  }

  private isFileExtensionValid(file: File): boolean {
    const allowedFileExtensions = this.allowedFileExtensions();
    if (!allowedFileExtensions) {
      return true;
    }
    return allowedFileExtensions.includes(this.getFileExtension(file));
  }

  private getFileExtension(file: File): string {
    return file.name.split('.').pop()!;
  }
}
